import { Component, inject } from '@angular/core';
import { BookviewerComponent } from './components/bookviewer/bookviewer.component';
import { AccessibilityService } from './services/accessibility.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [BookviewerComponent],
    standalone: true
})
export class AppComponent {
    private accessbilityService = inject(AccessibilityService);

    constructor() {
        this.accessbilityService.init();
    }
}
